export default __webpack_public_path__ + "static/media/spring-boot.5e950eb4.svg";